import { Component, input } from '@angular/core';

@Component({
  selector: 'sr-psa-govco-button',
  standalone: true,
  templateUrl: './govco-button.component.html',
  styleUrl: './govco-button.component.css'
})
export class GovcoButtonComponent {
  readonly variant = input<'primary' | 'secondary'>('primary');
  readonly type = input<'button' | 'submit'>('button');
}
